// extracted by mini-css-extract-plugin
var _1 = "EditorCommentBubble_anchor__3b9aa";
export { _1 as "anchor" }
